/**
 * Test IDs for QA automation.
 */
export const testIds = {
  nationalFuelRateTableDialogClose: "national-fuel-rate-table-dialog-close",
} as const;
